exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".list-card[data-v-43137c53] {\n  display: inline-block;\n  width: 100%;\n}\n", ""]);

